import React from 'react';
import { ColorConstants } from '@shared/constants';
import ImageWithLabel from './ImageWithLabel';
import ToolTipLight from '../tooltips/TooltipLight';
import { limitNumberOfCharacters } from '../../utils/strings';

const ImageWithLabelStyles = {
    label: {
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
        color: ColorConstants['black-50%'],
    },
};

const toolTipPosition = {
    top: '-25px',
    left: '10px',
};

const defaultProps = {
    label: '',
    tooltipLabel: '',
};

interface HeaderTagImageWithLabelProps {
    label: string;
    tooltipLabel: string;
    styles?: {
        image?: React.CSSProperties;
        wrapper?: React.CSSProperties;
    };
    shouldDisplayBackground?: boolean;
    src?: string;
    icon?: React.ReactNode;
}

const HeaderTagImageWithLabel = (props: HeaderTagImageWithLabelProps) => {
    const { label, tooltipLabel, styles } = props;
    return (
        <ToolTipLight
            position={toolTipPosition}
            text={tooltipLabel || label}
        >
            <ImageWithLabel
                {...props}
                label={limitNumberOfCharacters(label, 13)}
                styles={{ ...ImageWithLabelStyles, ...styles }}
            />
        </ToolTipLight>
    );
};

HeaderTagImageWithLabel.defaultProps = defaultProps;

export default HeaderTagImageWithLabel;
